export default {
  hero: {
    badge: "Hablemos",
    title: "Contáctanos",
    subtitle: "¿Listo para llevar tu negocio al siguiente nivel? Escríbenos y te respondemos en menos de 24 horas."
  },
  info: {
    email: {
      label: "Email"
    },
    response: {
      label: "Tiempo de Respuesta",
      value: "Menos de 24 horas",
      days: "Lunes a Viernes"
    },
    service: {
      label: "Servicio",
      value: "Global — 100% Online",
      languages: "Atendemos en Español e Inglés"
    }
  },
  social: {
    title: "Síguenos en Redes"
  },
  success: {
    title: "¡Mensaje Enviado!",
    subtitle: "Gracias por contactarnos. Te responderemos en menos de 24 horas.",
    cta: "Enviar otro mensaje"
  },
  form: {
    title: "Envíanos un Mensaje",
    subtitle: "Cuéntanos sobre tu proyecto y te ayudamos a crecer.",
    errors: {
      required: "Por favor completa los campos requeridos.",
      maxLength: "El mensaje no puede superar los 500 caracteres."
    },
    fields: {
      name: { label: "Nombre", placeholder: "Tu nombre completo" },
      email: { label: "Email" },
      phone: { label: "Teléfono / WhatsApp" },
      service: { label: "Servicio de Interés", placeholder: "Selecciona un servicio" },
      message: { label: "Mensaje", placeholder: "Cuéntanos sobre tu negocio y cómo podemos ayudarte..." }
    },
    cta: {
      sending: "Enviando...",
      label: "Enviar Mensaje"
    },
    services: {
      consulting: "Consultoría & Estrategia",
      other: "Otro"
    }
  },
  calendar: {
    badge: "Agenda una Sesión",
    titlePrefix: "Reserva tu ",
    titleHighlight: "Consultoría Gratuita",
    subtitle: "Agenda una sesión de 30 minutos con Cathy Roldán y descubre cómo podemos transformar tu negocio digital.",
    items: {
      i1: { title: "30 Minutos", desc: "Sesión enfocada en tus metas" },
      i2: { title: "100% Online", desc: "Zoom o Google Meet" },
      i3: { title: "Sin Costo", desc: "Primera consulta gratuita" }
    },
    cta: "Agendar Consultoría Gratis"
  }
};
